/*=========================================================================================
  File Name: module-notification-banner.js
  Description: NotificationBanner Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import state from './module-notification-banner-state';
import mutations from './module-notification-banner-mutations';
import actions from './module-notification-banner-actions';
import getters from './module-notification-banner-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
